export enum TypeOfOrderStakeholder {
  ACQUISITION_COORDINATOR = "acquisition_coordinator",
  LANDIS_BUYER_AGENT = "landis_buyer_agent",
  LISTING_AGENT = "listing_agent",
}
